import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { regexPatterns } from '@core/utils/regex-patterns';
import { formErrorMessages } from '@shared/components/forms/form-error-messages';
import { ReactiveFormBase } from './reactive-form-base';

@Component({
  template: ''
})
export class PasswordBaseComponent extends ReactiveFormBase {
  form: FormGroup;
  formErrors = {
    password: '',
    confirmPassword: '',
    pin: ''
  };

  isProcessing = false;
  userLoginName = '';
  validationMessages = {
    password: {
      required: formErrorMessages.common.required,
      passwordValidator: formErrorMessages.password.invalid
    },
    confirmPassword: {
      required: formErrorMessages.common.required,
      notEquivalent: 'Your passwords do not match',
      passwordValidator: formErrorMessages.password.invalid
    },
    pin: {
      required: formErrorMessages.common.required,
      pattern: formErrorMessages.common.invalid,
      maxlength: formErrorMessages.common.invalid
    }
  };

  constructor(protected formBuilder: FormBuilder) {
    super();
  }

  buildForm(): void {
    const passwordValidator = (control: AbstractControl): any => {
      if (control && control.value) {
        const password = control.value;
        if (password) {
          // password regex: /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&+=*]).*/,
          if (!password.match(regexPatterns.password)) {
            return { passwordValidator: true };
          }

          /*
          - This code below never works because userLoginName has never been set
          // split email on punctuation into tokens
          const emailTokens = this.userLoginName.split(/\W+/);
          for (const emailToken of emailTokens) {
            const tokenLength = emailToken.length;
            if (tokenLength > 2) {
              // Only validate if email token is more than 2 chars
              if (password.toLowerCase().indexOf(emailToken.toLowerCase()) !== -1) {
                return { passwordValidator: true };
              }
            }
          } */
        }
      }
    };

    this.form = new FormGroup({
      password: new FormControl('', {
        validators: [Validators.required, passwordValidator],
      }),
      confirmPassword: new FormControl('', {
        validators: [Validators.required, passwordValidator],
      }),
      pin: new FormControl('', {
        validators: [Validators.required,
        Validators.pattern(new RegExp(regexPatterns.pin)),
        Validators.maxLength(32)],
      })
    }, { validators: this.matchPasswords });

    this.form.valueChanges.subscribe(() => this.onValueChanged());
  }

  matchPasswords(group: FormGroup): any {
    const password = group.controls.password;
    const confirmPassword = group.controls.confirmPassword;

    // Dont activate validation until both fields have been touched
    if (password.pristine || confirmPassword.pristine) {
      return null;
    }

    group.markAsTouched();

    if (password.value === confirmPassword.value) {
      return null;
    }

    return confirmPassword.setErrors({
      notEquivalent: true
    });
  }
}
